import * as actionType from './actionTypes';

export const changeLanguage = (value) => ({
  'type': actionType.CHANGE_LANGUAGE,
  'value': value
});